<template>
  <div :class="['header-navigation', { 'opened': showNavigation !== undefined && showNavigation }]">
    <div class="container header-container">
      <div class="menu">
        <a class="menu-item" :href="siteUrl($t('top'))" rel="nofollow">{{ $t('Топ купонов') }}</a>
        <a class="menu-item" :href="siteUrl($t('shops'))"> {{ $t('Магазины') }}</a>
        <a class="menu-item" :href="siteUrl($t('categories'))" rel="nofollow">{{ $t('Категории') }}</a>
        <a class="menu-item" :href="siteUrl($t('today'))" rel="nofollow">{{ $t('Только сегодня') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import AppLanguageSelect from '../AppLanguageSelect.vue';

export default {
  name: 'app-header-navigation',

  components: {
    AppLanguageSelect,
  },

  props: {
    showNavigation: Boolean
  },

  data() {
    return {};
  },

  methods: {}
}
</script>

<style scoped>
.header-navigation {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  min-height: 40px;
  font-size: 14px;
  color: #ffffff;
  background-color: #3c91e6;
}

.language {
  position: relative;
  width: 190px;
  min-width: 190px;
}

.menu {
  display: flex;
  flex-wrap: wrap;
  margin: 0 0 0 10px;
}

.menu-item {
  display: flex;
  align-items: center;
  text-align: center;
  padding: 0 15px;
  height: 40px;
  font-weight: bold;
}

.menu-item:hover {
  background-color: #29629c;
}

.menu-item:active,
.menu-item.active {
  background-color: #2c316b;
}

@media (min-width: 1024px) {
  .header-navigation {
    display: flex;
  }
}

@media (max-width: 1023px) {
  .header-navigation {
    display: none;
  }

  .header-navigation.opened {
    display: flex;
  }

  .language {
    margin: 0 5px 0 0;
    width: 45px;
    min-width: 45px;
  }

  .menu {
    margin: 0;
  }
}

@media (max-width: 767px) {
  .menu-item {
    margin: 5px 15px 5px 0;
    padding: 0;
    height: auto;
    font-size: 12px;
  }

  .menu-item.active,
  .menu-item:hover {
    background-color: transparent;
  }
}
</style>